import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ITBMConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ITBMService } from './api/iTBM.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ITBMApiModule {
    public static forRoot(configurationFactory: () => ITBMConfiguration): ModuleWithProviders<ITBMApiModule> {
        return {
            ngModule: ITBMApiModule,
            providers: [ { provide: ITBMConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ITBMApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ITBMApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
